import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
//import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

// Prueba con xState
import Login from "./auth/loginState/reducer"
import CampusVirtual from "./campusvirtual/reducer"
import ControlEscolar from "./controlescolar/reducer"
import Caja from "./caja/reducer"
import Credenciales from "./credenciales/reducer"
import Documentos from "./documentos/reducer"
import Contribuyentes from "./contribuyentes/reducer"
import Cargos from "./cargos/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  CampusVirtual,
  ControlEscolar,
  Caja,
  Credenciales,
  Documentos,
  Contribuyentes,
  Cargos,
})

export default rootReducer
